export const jobSeekerTranslations = {
  en: {
    common: {
      brand: 'JOBSEEQR',
      productName: 'Job Seeker Workspace',
      forJobSeekers: 'For Job Seekers',
      language: 'Language',
      openMenu: 'Open navigation',
      english: 'EN',
      arabic: 'AR',
      loadingTitle: 'Preparing your workspace',
      loadingEyebrow: 'JOBSEEQR for Job Seekers',
      signOut: 'Sign out',
      openToWork: 'Open to work',
      profileInProgress: 'Profile in progress',
      viewProfile: 'View Profile',
      home: 'JOBSEEQR home',
    },
    navigation: {
      sections: {
        discover: 'DISCOVER',
        grow: 'GROW',
        you: 'YOU',
      },
      items: {
        opportunities: 'Opportunities',
        inbox: 'Inbox',
        outreach: 'Outreach',
        careerCoach: 'Career Coach',
        companyRadar: 'Company Radar',
        learningPathways: 'Learning Pathways',
        profile: 'Profile',
      },
      meta: {
        discover: 'Discover',
        grow: 'Grow',
        profile: 'View Profile',
      },
      status: {
        building: 'Building',
        ready: 'Ready',
      },
      workspaceLabel: 'Workspace navigation',
      descriptions: {
        opportunities: 'A structured live feed of roles worth your attention, with a focused detail pane for fast decisions.',
        inbox: 'Keep employer conversations, application updates, and next actions in one operating lane.',
        outreach: 'Track proactive company outreach and keep your search moving with intention.',
        careerCoach: 'Turn your profile into a sharper story with guided coaching and next-step prompts.',
        companyRadar: 'Watch hiring signals, shortlist target employers, and keep a cleaner sense of fit.',
        learningPathways: 'Map your next skill moves around the roles you actually want.',
        profile: 'Control how you show up to employers and keep your seeker signal strong.',
      },
      onboarding: {
        eyebrow: 'Onboarding Reserved',
        title: 'We kept the next step open right after signup.',
        body: 'This flow can expand into resume upload, search preferences, and coaching setup without breaking the first-run conversion path.',
        action: 'Mark onboarding as queued',
        queued: 'Onboarding queued',
      },
    },
    auth: {
      badge: 'For job seekers',
      brand: 'JOBSEEQR',
      title: 'Run your search with more signal.',
      copy: 'See what to pursue, who to reach, and where you stand.',
      benefits: [
        {
          title: 'Matches',
          body: 'Roles worth your time.',
        },
        {
          title: 'Outreach',
          body: 'Paths to the right people.',
        },
        {
          title: 'Company radar',
          body: 'Signals, blockers, next steps.',
        },
      ],
      preview: {
        opportunities: {
          label: 'Opportunities',
          rows: [
            { primary: 'AI Engineer', secondary: 'Hybrid • Remote' },
            { primary: 'Product Designer', secondary: 'MENA • Full-time' },
          ],
        },
        outreach: {
          label: 'Outreach',
          steps: ['Apply', 'Intro', 'Follow-up'],
        },
        radar: {
          label: 'Company Radar',
          tags: ['Apple', 'Stripe', 'NVIDIA'],
        },
      },
      highlights: [
        { value: '1', label: 'search workspace' },
        { value: '4', label: 'strategic layers' },
        { value: '0', label: 'spreadsheet juggling' },
      ],
      promise: [
        'Matched opportunities.',
        'Direct outreach.',
        'Clear next steps.',
      ],
      tabs: {
        signup: 'Sign up',
        login: 'Log in',
      },
      or: 'OR',
      eyebrow: {
        signup: 'Sign up',
        login: 'Log in',
        reset: 'Reset password',
      },
      heading: {
        signup: 'Get started',
        login: 'Welcome back :)',
        reset: 'Reset your password',
      },
      subheading: {
        signup: '',
        login: '',
        reset: 'We will send a reset link to your inbox.',
      },
      hero: {
        signupTitle: 'Your Personal Career Coach for the Global Job Market.',
        loginTitle: 'Your Personal Career Coach for the Global Job Market.',
        bottomLink: 'What Makes JOBSEEQR Different?',
        tags: [
          { icon: 'search', label: 'Automated Job Search' },
          { icon: 'route', label: 'Personalized Learning Plans' },
          { icon: 'bolt', label: 'Dream Company Roadmap' },
          { icon: 'compass', label: 'Interview Coaching' },
        ],
      },
      fields: {
        fullName: 'Full name',
        targetRole: 'Target role',
        email: 'Your Email Address',
        password: 'Create Your Password',
        passwordLogin: 'Enter Your Password',
      },
      placeholders: {
        fullName: 'e.g. Mira Khoury',
        targetRole: 'e.g. Product Designer',
        email: 'you@domain.com',
        passwordSignup: 'At least 10 characters',
        passwordLogin: 'Your password',
      },
      openToWork: 'Flag my profile as open to work from the start.',
      helper: '',
      actions: {
        createAccount: 'Create account',
        continue: 'Continue',
        login: 'Log in',
        sendReset: 'Send reset link',
        forgotPassword: 'Forgot password?',
        backToLogin: 'Back to login',
        needAccount: 'Need an account?',
        alreadyHaveAccount: 'Already have an account?',
        continueWithGoogle: 'Continue with Google',
      },
      account: {
        loginPrompt: 'Already have an account?',
        signupPrompt: 'Don’t have an account?',
      },
      legal: {
        signup: {
          prefix: 'By creating an account, you agree to our',
          terms: 'Terms of Service',
          middle: 'and',
          privacy: 'Privacy Policy',
          suffix: '.',
        },
        login: {
          prefix: 'By signing in, you agree to our',
          terms: 'Terms of Service',
          middle: 'and',
          privacy: 'Privacy Policy',
          suffix: '.',
        },
        reset: {
          prefix: 'By continuing, you agree to our',
          terms: 'Terms of Service',
          middle: 'and',
          privacy: 'Privacy Policy',
          suffix: '.',
        },
      },
      defaults: {
        username: 'Job Seeker',
      },
      errors: {
        fullNameRequired: 'Start with your full name.',
        invalidEmail: 'Use a valid email address.',
        weakPassword: 'Use at least 10 characters for your password.',
        missingPassword: 'Enter your password.',
        emailAlreadyInUse: 'That email already has an account. Log in instead, or use another address.',
        invalidCredentials: 'That email and password combination did not work.',
        tooManyRequests: 'Too many attempts from this device. Try again in a few minutes.',
        generic: 'Something went wrong. Please try again.',
      },
      messages: {
        resetSent: 'Reset link sent. Check your inbox.',
      },
      pending: 'Please wait...',
    },
    opportunities: {
      summary: {
        liveRoles: 'Live roles',
        locations: 'Locations',
        view: 'View',
        curated: 'Focused',
      },
      filters: {
        search: 'Search roles, companies, locations',
        schedule: 'Schedule',
        workMode: 'Work mode',
        all: 'All',
      },
      states: {
        loading: 'Loading opportunities...',
        empty: 'No opportunities match the filters you applied. Widen the search and try again.',
        select: 'Select an opportunity to inspect the role details.',
      },
      actions: {
        openApplication: 'Open application',
        applyNow: 'Apply now',
      },
      feedback: {
        missingDestination: 'This role does not have an application destination configured yet.',
        submitted: 'Application submitted. The role has been added to your connection stream.',
        failed: 'Something went wrong while submitting your application.',
      },
      labels: {
        partner: 'JOBSEEQR Partner',
        flexible: 'Flexible',
        locationTbd: 'Location to be confirmed',
        untitledRole: 'Untitled role',
        roleBrief: 'Role brief',
        roleBriefTitle: 'What this opportunity looks like',
        signalSummary: 'Signal summary',
        signalSummaryTitle: 'Quick read before you apply',
        noDescription: 'No description was added yet.',
        hiringCompany: 'Hiring company',
        workModel: 'Work model',
        schedule: 'Schedule',
        applicationRoute: 'Application route',
        notSpecified: 'Not specified',
        directVia: 'Direct via JOBSEEQR',
        externalLink: 'External link',
      },
    },
    workspaces: {
      inbox: {
        accent: 'Inbox',
        title: 'Your hiring conversations will land here',
        description: 'This workspace is reserved for employer replies, application updates, and reminders that help a job seeker keep momentum.',
        stats: [
          { label: 'Priority lanes', value: 'Applications' },
          { label: 'Default rhythm', value: 'Daily digest' },
          { label: 'State', value: 'Reserved' },
        ],
        lanes: [
          {
            title: 'Employer Threads',
            body: 'Centralize message history, recruiter nudges, and scheduling notes without losing context between roles.',
          },
          {
            title: 'Application Signals',
            body: 'Promote status changes into clear cards so job seekers know what needs action versus what can wait.',
          },
          {
            title: 'Suggested Replies',
            body: 'Leave space for response helpers that can draft concise follow-ups when the conversation gets moving.',
          },
        ],
      },
      outreach: {
        accent: 'Outreach',
        title: 'Proactive search, not passive waiting',
        description: 'This workspace is reserved for targeted company outreach so job seekers can keep a clean pipeline of warm conversations.',
        stats: [
          { label: 'Mode', value: 'Outbound' },
          { label: 'Cadence', value: 'Planned' },
          { label: 'Priority', value: 'Intentional' },
        ],
        lanes: [
          {
            title: 'Company List',
            body: 'Track who you contacted, when you reached out, and what story angle you used for each company.',
          },
          {
            title: 'Follow-up Queue',
            body: 'Surface who needs a second touch and which conversations are cooling off before they go silent.',
          },
          {
            title: 'Messaging Lab',
            body: 'Reserve space for personalized outreach drafts tied to specific opportunities and companies.',
          },
        ],
      },
      careerCoach: {
        accent: 'Career Coach',
        title: 'A coach layer that sharpens positioning',
        description: 'This screen is reserved for narrative coaching, interview prep, and next-best-action guidance around the seeker profile.',
        stats: [
          { label: 'Focus', value: 'Narrative' },
          { label: 'Format', value: 'Guided prompts' },
          { label: 'Readiness', value: 'Reserved' },
        ],
        lanes: [
          {
            title: 'Story Tightening',
            body: 'Turn raw experience into a sharper personal pitch that matches the roles you are targeting.',
          },
          {
            title: 'Interview Rehearsals',
            body: 'Prepare for high-signal interviews with concise drills and practice loops tailored to role type.',
          },
          {
            title: 'Weekly Plan',
            body: 'Translate ambition into a short operating plan with actions that can actually get done this week.',
          },
        ],
      },
      companyRadar: {
        accent: 'Company Radar',
        title: 'Keep target companies in view',
        description: 'This screen is reserved for employer tracking, hiring signals, and fit notes so search energy goes where it matters.',
        stats: [
          { label: 'Lens', value: 'Target accounts' },
          { label: 'Signal type', value: 'Hiring motion' },
          { label: 'State', value: 'Structured' },
        ],
        lanes: [
          {
            title: 'Watchlist',
            body: 'Pin companies you care about and track who is hiring, where the movement is, and what changed recently.',
          },
          {
            title: 'Fit Notes',
            body: 'Capture why a company matters to you before the application sprint begins and the context gets blurry.',
          },
          {
            title: 'Warm Entry Paths',
            body: 'Reserve space for referrals, hiring manager signals, and smart angles for getting into the conversation.',
          },
        ],
      },
      learningPathways: {
        accent: 'Learning Pathways',
        title: 'Skill-building tied to actual opportunity gaps',
        description: 'This workspace is reserved for learning plans that close the gap between your current profile and the roles you want.',
        stats: [
          { label: 'Orientation', value: 'Career-aligned' },
          { label: 'Pace', value: 'Modular' },
          { label: 'State', value: 'Ready' },
        ],
        lanes: [
          {
            title: 'Target Role Blueprint',
            body: 'Start from the destination role and break the required capabilities into practical learning blocks.',
          },
          {
            title: 'Gap Mapping',
            body: 'Highlight missing signals that keep appearing across opportunities and turn them into concrete milestones.',
          },
          {
            title: 'Progress Markers',
            body: 'Leave room for proof of work, completed steps, and employer-facing credibility cues.',
          },
        ],
      },
    },
    profile: {
      identity: 'Identity',
      title: 'Shape what employers see first',
      fields: {
        fullName: 'Full name',
        email: 'Email',
        targetRole: 'Target role',
        location: 'Location',
        phoneNumber: 'Phone number',
        summary: 'Career summary',
      },
      placeholders: {
        targetRole: 'e.g. Growth Product Manager',
        location: 'e.g. Beirut',
        phoneNumber: '+961 ...',
        summary: 'Write a compact summary of the work you want, what you are good at, and what employers should notice.',
      },
      openToWork: 'Show me as open to work.',
      save: 'Save profile',
      saving: 'Saving...',
      updated: 'Profile updated.',
      failed: 'Unable to save profile right now.',
      readiness: {
        eyebrow: 'Readiness',
        title: 'Job-seeker signal',
        status: 'Status',
        onboarding: 'Onboarding',
        targetRole: 'Target role',
        live: 'Live',
        private: 'Private',
        unset: 'Unset',
      },
      nextLayer: {
        eyebrow: 'Next layer',
        title: 'Onboarding placeholders',
        body: 'This page leaves room for the next screens we are likely to add after auth: CV upload, search preferences, work authorization, and coaching setup.',
      },
    },
    opportunityFeed: {
      title: 'Jobs I found for you',
      sort: { label: 'Sort by:', aria: 'Sort jobs', recommended: 'Recommended', recent: 'Most recent' },
      manual: {
        title: 'Search open jobs',
        aria: 'Manual job search',
        queryLabel: 'Role, skill, or company',
        queryPlaceholder: 'Role, skill, or company',
        locationLabel: 'Job location',
        locationPlaceholder: 'City or country',
        workModeLabel: 'Work mode',
        allModes: 'All work modes',
        remote: 'Remote',
        hybrid: 'Hybrid',
        onSite: 'On-site',
        resultCount: 'Showing {count} jobs',
        listing: 'Open listing',
        empty: 'No open jobs match those search terms. Try removing one of the filters.',
      },
      promo: {
        eyebrow: 'JOBSEEQR PRO',
        title: 'Let the right jobs come to you.',
        description: 'JOBSEEQR finds jobs for you based on your experience, preferred roles and locations, then ranks the jobs that fit you best.',
        action: 'Start my Scout · $20/month',
        expiredTitle: 'Keep your job search active.',
        expiredDescription: 'Your roles, locations and preferences are already saved. Upgrade so JOBSEEQR can continue searching for jobs for you.',
        expiredAction: 'Keep my Scout active · $20/month',
        opening: 'Opening secure checkout…',
      },
      trial: {
        eyebrow: 'SCOUT TRIAL ACTIVE',
        closingEyebrow: 'SCOUT TRIAL · LESS THAN A DAY LEFT',
        title: 'Your Scout is working',
        includedUntil: 'Personalized search and Scout outreach are included until {date}.',
        closingTitle: 'Your Scout will pause on {day}.',
        closingDescription: 'Upgrade to continue your automated job search and outreach without setting it up again.',
        oneMatch: 'Scout has ranked {count} personal match so far.',
        matches: 'Scout has ranked {count} personal matches so far.',
        action: 'Keep it working after the trial',
        closingAction: 'Continue with Pro · $20/month',
        opening: 'Opening secure checkout…',
      },
      cv: {
        title: 'Get better job matches',
        description: 'For better matches, please upload a CV or build one with our Career Coach.',
        upload: 'Upload CV',
        uploading: 'Uploading…',
        build: 'Build one with Career Coach',
        buildPrefill: 'Help me build a CV from scratch.',
        pdfOnly: 'Please choose a PDF CV.',
        refreshFailed: 'Your CV was uploaded, but Scout could not refresh the matches yet. Please try again later.',
        uploadedRefreshing: 'CV uploaded. Scout is now improving your matches.',
        uploaded: 'CV uploaded. It will be used for your future matches.',
        uploadFailed: 'We could not upload your CV. Please try again.',
      },
      tabs: { aria: 'Job feed sections', all: 'Job matches', recent: 'Last 24 hours', browse: 'Browse all', applied: 'Applied' },
      states: {
        updated: 'Your updated Scout is getting fresh matches now. I am keeping your previous Scout jobs visible here until the new results are ready.',
        searching: 'Your Scout is searching across the web. Live jobs related to your target role are shown below while personalized matches are prepared.',
        empty: 'Personalized matches are not ready yet. Live jobs related to your target role are shown below.',
        incomplete: 'Scout received partial market coverage and will keep refreshing. Your previous matches stay safe.',
        failed: 'Scout could not complete its latest market refresh and will retry automatically. Your previous matches stay safe.',
        setup: 'Your Job Scout is being created now. Personalized matches will appear here as soon as it finishes.',
        retry: 'Your answers are saved. Job Scout setup hit a temporary problem and is retrying automatically.',
        loadingApplications: 'Loading your application activity…',
        noApplied: "You haven't applied to any jobs in this feed yet.",
        noRecent: 'No new jobs were found in the last 24 hours.',
        noMatches: 'No job matches are ready yet.',
        reviewPending: 'Your Scout is retrying a job review. You can keep browsing while it finishes.',
        reviewUnavailable: 'Some job reviews could not be completed. You can still browse jobs and use any matches already available.',
        reviewUncertain: 'Some jobs need more information before your Scout can confirm a match.',
      },
      jobs: {
        untitled: 'Untitled role', unknownCompany: 'Unknown company', detailsPending: 'Details coming soon',
        salaryUnavailable: 'Salary unavailable', today: 'Posted today', yesterday: 'Posted yesterday', daysAgo: 'Posted {count} days ago',
        matchPending: 'Match pending', excellent: 'Excellent match', strong: 'Strong match', good: 'Good match', potential: 'Potential match',
        status: 'Job status', new: 'New', applied: 'Applied', notForMe: 'Not for me', why: 'Tell Scout why:',
        feedbackFailed: 'I could not save that feedback. Please try again.',
      },
      dismiss: { wrongRole: 'Wrong role', wrongIndustry: 'Wrong industry', wrongLocation: 'Wrong location', tooSenior: 'Too senior', tooJunior: 'Too junior', other: 'Something else' },
      market: { title: 'Jobs related to your target role', description: 'These are live JOBSEEQR jobs you can review while Scout prepares and ranks your personal matches.', general: 'Related listing', empty: 'No related live jobs are available yet.' },
      radar: { title: 'Company Shortlist', openAria: 'Open company shortlist', open: 'Open shortlist', loading: 'Loading company radar', emptyTitle: 'Build a target-company roadmap', emptyDescription: 'Research offices, fit, blockers, visas, and next steps.' },
      tokens: { onSite: 'On-site', fullTime: 'Full-time', partTime: 'Part-time', perYear: '/yr', upTo: 'Up to' },
    },
    careerCoachHub: {
      title: 'What would you like to do today?',
      nodes: { interviews: 'Practice\nInterviews', ask: 'Ask Me\nAnything', scout: 'Configure\nJob Scout', careers: 'Explore\nCareer Paths' },
      update: 'Your updated Job Scout is running in the background. Your old jobs stay visible until fresh matches are ready.',
      focusTitle: 'Your main focus now is…',
      scoutTitle: 'Your Job Scout',
      scoutDescription: 'I will be finding open roles with these titles for you.',
      noTitles: 'No titles configured yet.',
      addMore: 'Add More',
      defaultFocus: 'Right now, I am looking for opportunities that fit my experience, preferences, and next career move.',
    },
    activeGoals: {
      title: 'Weekly Goals', history: 'History', weeklyHistory: 'Weekly History', save: 'Save', cancel: 'Cancel', edit: 'Edit',
      target: '{title} target', applicationPeriod: 'Application goal period', perDay: 'per day', perWeek: 'per week',
      empty: 'Your career agent can help you stay consistent by setting weekly goals for applications, interview practice, and networking.',
      setGoals: 'Set goals', today: 'Today', thisWeek: 'This week', deadlineToday: 'today', deadlineWeek: 'this week',
      completeToday: 'Complete {target} {unit} today', completeBy: 'Complete {target} {unit} by {date}', completeWeek: 'Complete {target} {unit} this week',
      undo: 'Undo last {unit}', progress: '{current} of {target} {unit} completed', weekTotal: 'This week: {count}',
      networkingRecommended: 'Recommended people to network with',
      types: {
        applications: { title: 'Job applications', goalTitle: 'Application goal', unit: 'applications', targetUnit: 'job applications', logLabel: 'Log application' },
        interviews: { title: 'Practice interviews', goalTitle: 'Interview goal', unit: 'interviews', targetUnit: 'practice interviews', logLabel: 'Log interview' },
        networking: { title: 'Networking chats', goalTitle: 'Networking goal', unit: 'chats', targetUnit: 'networking chats', logLabel: 'Log chat' },
      },
    },
    inboxPage: {
      loading: 'Loading…', label: 'Inbox', title: 'Inbox', subtitle: 'Companies you are actively contacting', sections: 'Inbox sections',
      messages: 'Messages', outreach: 'Outreach', noConversations: 'No active conversations yet.', noOutreach: 'No active outreach sequences yet.',
      company: 'Company', rolePending: 'Role in progress', unread: 'Unread messages', noMessages: 'No messages yet', loadingMessages: 'Loading messages…', loadingOutreach: 'Loading outreach',
      recipientsEmails: '{recipients} recipients · {emails} emails', contacts: 'Outreach contacts', contact: 'Contact', hiringTeam: 'Hiring team', cancelContact: 'Cancel contact',
      pause: 'Pause', cancel: 'Cancel', back: 'Back', noThreadMessages: 'No messages in this thread yet.', typeMessage: 'Type a message', message: 'Message', send: 'Send message', selectCompany: 'Select a company to view messages.',
      status: { active: 'Active', paused: 'Paused', cancelled: 'Cancelled', completed: 'Completed' },
    },
    profilePage: {
      jobSeeker: 'Job Seeker', openToWork: 'Open to work', menu: 'Profile menu', edit: 'Edit profile', settings: 'Settings', signOut: 'Sign out',
      editLabel: 'Edit profile', firstName: 'First name', lastName: 'Last name', email: 'Email', phone: 'Phone', location: 'Location', linkedin: 'LinkedIn', portfolio: 'Portfolio', saving: 'Saving…', save: 'Save changes', cancel: 'Cancel',
      contact: 'Contact details', noEmail: 'No email added', noPhone: 'No phone added', noLocation: 'No location added', noLinkedin: 'No LinkedIn added', uploadedCv: 'Uploaded CV', noCv: 'No CV uploaded yet', noPortfolio: 'No portfolio link added',
      assessedBadges: 'Assessed Skill Badges', certificates: 'JOBSEEQR Certificates', showLess: 'Show less', more: '+ {count} more',
      billing: {
        title: 'Billing', freePlan: 'Free plan', proPlan: 'Pro plan', trialEnds: 'Scout trial ends {date}', accessEnds: 'Pro access ends {date}',
        upgradeTitle: 'Move your job search forward with Pro.', upgradeDescription: 'Scout, outreach, Learning Pathways, interview practice, Company Radar and Career Coach.',
        freePrice: '$0', proPrice: '$20', perMonth: '/month', upgrade: 'Upgrade to Pro · $20/month', manage: 'Manage billing', opening: 'Opening…',
        success: "You're on Pro. Access is updating now.", cancelled: 'Checkout canceled. No charge was made.',
      },
    },
    careerPathsPage: {
      label: 'Career Paths', nextMoves: 'Your Next Moves', categories: 'Career path categories', back: 'Back', description: 'Compare realistic roles by fit, hiring outlook, and the work needed to get there.', roleDescription: 'Review the hiring outlook, fit, gaps, and next steps for this role.',
      intentTitle: 'What kind of next move are you exploring?', intentDescription: 'Choose one direction. If you choose Pivot, tell us the field or role you want.', direction: 'Career path direction', pivotQuestion: 'What field or role do you want to pivot to?', pivotPlaceholder: 'Example: Data Analyst', starting: 'Starting…', showPaths: 'Show my paths',
      modes: { promotion: { label: 'Grow', prompt: 'Grow in my current path', description: 'Pick this if you want a higher-level role in the same kind of work.' }, parallel: { label: 'Move', prompt: 'Move to a related role', description: 'Pick this if you want a nearby role that uses skills you already have.' }, pivoting: { label: 'Pivot', prompt: 'Pivot into something new', description: 'Pick this if you want a new kind of role and need a clear plan.' } },
      loadingTitle: 'Loading your career paths', loadingDescription: 'Checking whether you already have saved results.', buildingTitle: 'Building your next moves', buildingDescription: 'This can take a moment while we check your profile and the market.', errorTitle: 'Career path generation needs another try', errorFallback: 'One or more sections did not finish.', startError: 'Unable to start career path generation.', retry: 'Retry', empty: 'No recommendations are available for this section yet.', sources: 'Sources', source: 'Source', pathSummary: 'Path summary', pathRatings: 'Path ratings',
      fit: 'Fit', work: 'Work', outlook: 'Outlook', hiringOutlook: 'Hiring outlook', effort: 'How much work it takes', moreProof: 'Expect more proof-building.', currentProof: 'Build from your current proof.', alreadyHave: 'Skills you already have', skillsToBuild: 'Skills to build', next30: '30-day next steps', next90: '90-day path', people: 'People to talk to', official: 'Official data', estimate: 'Estimate', liveCheck: 'Needs live check', growing: 'Growing', limited: 'Limited', steady: 'Steady', rolesExist: 'Open roles exist', confirmPosts: 'Confirm with current job posts.', openings: '{count} openings/year', projected: '{value}% projected change',
      recommendedPath: 'Recommended path', ninetyDays: '90 days', fitLabels: { strong: 'Strong', promising: 'Promising', stretch: 'Stretch' }, effortLabels: { low: 'Low', medium: 'Medium', high: 'High' },
    },
    askAnythingPage: {
      label: 'Ask Me Anything', loadingChats: 'Loading career coach chats', loading: 'Loading…', back: 'Back', defaultTitle: 'New Career Coaching Conversation',
      openChats: 'Open previous chats', previousChats: 'Previous chats', chats: 'Chats', closeChats: 'Close previous chats', newChat: 'New chat', startFresh: 'Start fresh', newChatDescription: 'Career, companies, courses, salaries, CVs, industries, interviews, or JOBSEEQR.', coach: 'JOBSEEQR career coach', answerLoading: 'Answer loading', noMessages: 'No messages yet', deleteChat: 'Delete {title}', delete: 'Delete chat',
      helpTitle: 'What can I help with?', suggested: 'Suggested questions', suggestions: ['How can I improve my CV?', 'Which roles fit me best?', 'What salary should I target?', 'How should I prepare for interviews?'],
      sources: 'Sources', cvOptions: 'CV options', cvSections: 'CV draft sections', copy: 'Copy answer', chooseCv: 'Choose a CV option', chooseAbove: 'Select an option above.', placeholder: 'Type a career question', question: 'Ask Me Anything question', send: 'Send question',
      searching: 'Searching up-to-date career sources…', brewing: 'Preparing your answer…', noAnswer: 'I found sources, but could not compose an answer.', blocked: 'I can only help with career and JOBSEEQR questions.', temporaryError: 'Ask Me Anything hit a temporary issue.',
      cvSessionTitle: 'CV Build Edit Session', cvReading: 'Reading your CV…', cvThinking: 'Thinking about your CV…', cvGenerating: 'Generating and saving your CV…', cvCreatingSaving: 'Creating and saving your CV…', cvSaved: 'Done. I created the new CV and saved it to your profile.\n\n[Open the saved CV]({url})', cvTemporaryError: 'The CV build-edit session hit a temporary issue.',
    },
    settings: {
      backToProfile: 'Back to Profile',
      title: 'Settings',
      appearance: {
        title: 'Appearance',
        description: 'Choose the brightness that feels best for your workspace.',
        light: 'Light',
        dark: 'Dark',
        switchToLight: 'Switch to light mode',
        switchToDark: 'Switch to dark mode',
      },
      language: {
        eyebrow: 'LANGUAGE & DIRECTION',
        title: 'Choose your workspace language',
        description: 'This changes navigation, controls, and the language JOBSEEQR uses when it speaks with you.',
        englishName: 'English',
        englishNative: 'English',
        arabicName: 'Arabic',
        arabicNative: 'العربية',
        ltr: 'Left to right',
        rtl: 'Right to left',
        selected: 'Selected',
        saving: 'Saving preference…',
        saved: 'Language preference saved.',
        failed: 'We could not save your language preference. Please try again.',
      },
      legal: {
        title: 'Legal',
        terms: 'Terms of Service',
        privacy: 'Privacy Policy',
      },
      email: {
        title: 'Automated Outreach Email',
        description: 'Connect Gmail or Outlook so JOBSEEQR can send and read outreach replies for your active sequences.',
        checking: 'Checking…',
        connected: 'Connected',
        notConnected: 'Not connected',
        connectedAccount: 'Connected account',
        connectYour: 'Connect your',
        connect: 'Connect',
        opening: 'Opening…',
        disconnect: 'Disconnect',
        disconnecting: 'Disconnecting…',
        disconnected: 'Email disconnected.',
        checkingProviders: 'Checking connected email providers',
        connectedForOutreach: 'connected for automated outreach.',
        connectionFailed: 'Email connection failed',
      },
      danger: {
        title: 'Danger Zone',
        description: 'Delete your profile, application index, and related message connections.',
        confirmation: 'Type DELETE to confirm',
        delete: 'Delete account',
        deleting: 'Deleting…',
        recentLogin: 'Please log out, log back in, and retry account deletion.',
        failed: 'Account deletion failed. Please try again.',
      },
    },
  },
  ar: {
    common: {
      brand: 'JOBSEEQR',
      productName: 'مساحة الباحث عن عمل',
      forJobSeekers: 'للباحثين عن عمل',
      language: 'اللغة',
      openMenu: 'فتح التنقل',
      english: 'EN',
      arabic: 'AR',
      loadingTitle: 'نجهّز لك مساحة العمل',
      loadingEyebrow: 'JOBSEEQR للباحثين عن عمل',
      signOut: 'تسجيل الخروج',
      openToWork: 'متاح للعمل',
      profileInProgress: 'الملف قيد الإعداد',
      viewProfile: 'عرض الملف الشخصي',
      home: 'الصفحة الرئيسية لـ JOBSEEQR',
    },
    navigation: {
      sections: {
        discover: 'اكتشف',
        grow: 'طوّر',
        you: 'أنت',
      },
      items: {
        opportunities: 'الفرص',
        inbox: 'الوارد',
        outreach: 'التواصل',
        careerCoach: 'المدرب المهني',
        companyRadar: 'رادار الشركات',
        learningPathways: 'مسارات التعلّم',
        profile: 'الملف الشخصي',
      },
      meta: {
        discover: 'اكتشف',
        grow: 'طوّر',
        profile: 'عرض الملف الشخصي',
      },
      status: {
        building: 'قيد الإنشاء',
        ready: 'جاهز',
      },
      workspaceLabel: 'التنقل في مساحة العمل',
      descriptions: {
        opportunities: 'تدفّق منظم للوظائف الجديرة بالاهتمام مع لوحة تفاصيل تساعدك على اتخاذ القرار بسرعة.',
        inbox: 'احتفظ بمحادثات أصحاب العمل وتحديثات الطلبات والخطوات التالية في مسار واحد واضح.',
        outreach: 'تابع تواصلك الاستباقي مع الشركات وحافظ على بحثك بحركة مقصودة.',
        careerCoach: 'حوّل ملفك إلى قصة أقوى مع إرشاد مهني وخطوات عملية.',
        companyRadar: 'راقب إشارات التوظيف وحدد الشركات المستهدفة واحفظ وضوح الملاءمة.',
        learningPathways: 'خطط لتطوير مهاراتك حول الوظائف التي تريدها فعلًا.',
        profile: 'تحكم بكيفية ظهورك لأصحاب العمل وحافظ على قوة إشاراتك المهنية.',
      },
      onboarding: {
        eyebrow: 'مساحة محجوزة للإعداد',
        title: 'تركنا الخطوة التالية مفتوحة مباشرة بعد التسجيل.',
        body: 'يمكن لهذا المسار أن يتوسع لاحقًا ليشمل رفع السيرة الذاتية وتفضيلات البحث وإعدادات التدريب من دون كسر تجربة البداية.',
        action: 'وضع الإعداد في قائمة الانتظار',
        queued: 'تمت جدولة الإعداد',
      },
    },
    auth: {
      badge: 'للباحثين عن عمل',
      brand: 'JOBSEEQR',
      title: 'أدر بحثك بوضوح أكبر.',
      copy: 'اعرف ما يستحق المتابعة، ومن يجب الوصول إليه، وأين تقف الآن.',
      benefits: [
        {
          title: 'الوظائف المطابقة',
          body: 'فرص تستحق وقتك.',
        },
        {
          title: 'التواصل',
          body: 'طرق للوصول إلى الأشخاص المناسبين.',
        },
        {
          title: 'رادار الشركات',
          body: 'إشارات وعوائق وخطوات تالية.',
        },
      ],
      preview: {
        opportunities: {
          label: 'الفرص',
          rows: [
            { primary: 'مهندس ذكاء اصطناعي', secondary: 'هجين • عن بُعد' },
            { primary: 'مصمم منتجات', secondary: 'الشرق الأوسط • دوام كامل' },
          ],
        },
        outreach: {
          label: 'التواصل',
          steps: ['تقديم', 'رسالة تعريفية', 'متابعة'],
        },
        radar: {
          label: 'رادار الشركات',
          tags: ['Apple', 'Stripe', 'NVIDIA'],
        },
      },
      highlights: [
        { value: '1', label: 'مساحة بحث واحدة' },
        { value: '4', label: 'طبقات استراتيجية' },
        { value: '0', label: 'فوضى الجداول' },
      ],
      promise: [
        'فرص مطابقة.',
        'تواصل مباشر.',
        'خطوات أوضح.',
      ],
      tabs: {
        signup: 'إنشاء حساب',
        login: 'تسجيل الدخول',
      },
      or: 'أو',
      eyebrow: {
        signup: 'إنشاء حساب',
        login: 'تسجيل الدخول',
        reset: 'إعادة التعيين',
      },
      heading: {
        signup: 'ابدأ الآن',
        login: 'أهلًا بعودتك :)',
        reset: 'إعادة تعيين كلمة المرور',
      },
      subheading: {
        signup: '',
        login: '',
        reset: 'سنرسل رابط إعادة التعيين إلى بريدك الإلكتروني.',
      },
      hero: {
        signupTitle: 'مدربك المهني الشخصي لسوق العمل العالمي.',
        loginTitle: 'مدربك المهني الشخصي لسوق العمل العالمي.',
        bottomLink: 'ما الذي يجعل JOBSEEQR مختلفًا؟',
        tags: [
          { icon: 'search', label: 'بحث وظيفي آلي' },
          { icon: 'route', label: 'خطط تعلم مخصصة' },
          { icon: 'bolt', label: 'خارطة طريق لشركة أحلامك' },
          { icon: 'compass', label: 'تدريب على المقابلات' },
        ],
      },
      fields: {
        fullName: 'الاسم الكامل',
        targetRole: 'الدور المستهدف',
        email: 'عنوان بريدك الإلكتروني',
        password: 'أنشئ كلمة المرور',
        passwordLogin: 'أدخل كلمة المرور',
      },
      placeholders: {
        fullName: 'مثال: ميرا خوري',
        targetRole: 'مثال: مصممة منتجات',
        email: 'you@domain.com',
        passwordSignup: '10 أحرف على الأقل',
        passwordLogin: 'كلمة المرور',
      },
      openToWork: 'ضع إشارة أنني متاح للعمل من البداية.',
      helper: '',
      actions: {
        createAccount: 'إنشاء الحساب',
        continue: 'متابعة',
        login: 'تسجيل الدخول',
        sendReset: 'إرسال رابط إعادة التعيين',
        forgotPassword: 'هل نسيت كلمة المرور؟',
        backToLogin: 'العودة إلى الدخول',
        needAccount: 'تحتاج إلى حساب؟',
        alreadyHaveAccount: 'لديك حساب بالفعل؟',
        continueWithGoogle: 'المتابعة باستخدام Google',
      },
      account: {
        loginPrompt: 'لديك حساب بالفعل؟',
        signupPrompt: 'ليس لديك حساب؟',
      },
      legal: {
        signup: {
          prefix: 'بإنشاء حساب، فإنك توافق على',
          terms: 'شروط الخدمة',
          middle: 'و',
          privacy: 'سياسة الخصوصية',
          suffix: '.',
        },
        login: {
          prefix: 'بتسجيل الدخول، فإنك توافق على',
          terms: 'شروط الخدمة',
          middle: 'و',
          privacy: 'سياسة الخصوصية',
          suffix: '.',
        },
        reset: {
          prefix: 'بالمتابعة، فإنك توافق على',
          terms: 'شروط الخدمة',
          middle: 'و',
          privacy: 'سياسة الخصوصية',
          suffix: '.',
        },
      },
      defaults: {
        username: 'باحث عن عمل',
      },
      errors: {
        fullNameRequired: 'ابدأ باسمك الكامل.',
        invalidEmail: 'استخدم بريدًا إلكترونيًا صالحًا.',
        weakPassword: 'استخدم كلمة مرور من 10 أحرف على الأقل.',
        missingPassword: 'أدخل كلمة المرور.',
        emailAlreadyInUse: 'هذا البريد الإلكتروني لديه حساب بالفعل. سجّل الدخول أو استخدم بريدًا آخر.',
        invalidCredentials: 'بيانات البريد الإلكتروني وكلمة المرور غير صحيحة.',
        tooManyRequests: 'عدد كبير من المحاولات من هذا الجهاز. حاول مجددًا بعد بضع دقائق.',
        generic: 'حدث خطأ ما. حاول مرة أخرى.',
      },
      messages: {
        resetSent: 'تم إرسال رابط إعادة التعيين. تحقق من بريدك الإلكتروني.',
      },
      pending: 'يرجى الانتظار...',
    },
    opportunities: {
      summary: {
        liveRoles: 'الوظائف المباشرة',
        locations: 'المواقع',
        view: 'العرض',
        curated: 'مركّز',
      },
      filters: {
        search: 'ابحث في الوظائف والشركات والمواقع',
        schedule: 'الدوام',
        workMode: 'نمط العمل',
        all: 'الكل',
      },
      states: {
        loading: 'يتم تحميل الفرص...',
        empty: 'لا توجد فرص تطابق عوامل التصفية الحالية. وسّع البحث وحاول مرة أخرى.',
        select: 'اختر فرصة لمراجعة تفاصيل الوظيفة.',
      },
      actions: {
        openApplication: 'فتح التقديم',
        applyNow: 'قدّم الآن',
      },
      feedback: {
        missingDestination: 'هذه الوظيفة لا تحتوي بعد على مسار تقديم مضبوط.',
        submitted: 'تم إرسال الطلب. أُضيفت الوظيفة إلى مسار الاتصال الخاص بك.',
        failed: 'حدث خطأ أثناء إرسال الطلب.',
      },
      labels: {
        partner: 'شريك JOBSEEQR',
        flexible: 'مرن',
        locationTbd: 'سيتم تحديد الموقع',
        untitledRole: 'وظيفة بدون عنوان',
        roleBrief: 'ملخص الدور',
        roleBriefTitle: 'كيف تبدو هذه الفرصة',
        signalSummary: 'ملخص الإشارات',
        signalSummaryTitle: 'قراءة سريعة قبل التقديم',
        noDescription: 'لم تتم إضافة وصف بعد.',
        hiringCompany: 'الشركة',
        workModel: 'نمط العمل',
        schedule: 'الدوام',
        applicationRoute: 'مسار التقديم',
        notSpecified: 'غير محدد',
        directVia: 'مباشر عبر JOBSEEQR',
        externalLink: 'رابط خارجي',
      },
    },
    workspaces: {
      inbox: {
        accent: 'الوارد',
        title: 'هنا ستصل محادثات التوظيف الخاصة بك',
        description: 'هذه المساحة مخصصة لردود أصحاب العمل وتحديثات الطلبات والتنبيهات التي تساعد الباحث عن عمل على الحفاظ على الزخم.',
        stats: [
          { label: 'المسارات المهمة', value: 'الطلبات' },
          { label: 'الإيقاع الافتراضي', value: 'ملخص يومي' },
          { label: 'الحالة', value: 'محجوزة' },
        ],
        lanes: [
          {
            title: 'محادثات أصحاب العمل',
            body: 'اجمع تاريخ الرسائل والتنبيهات وملاحظات الجدولة في مكان واحد من دون فقدان السياق.',
          },
          {
            title: 'إشارات الطلبات',
            body: 'حوّل تغييرات الحالة إلى بطاقات واضحة حتى تعرف ما يحتاج إلى إجراء وما يمكنه الانتظار.',
          },
          {
            title: 'ردود مقترحة',
            body: 'اترك مساحة لمساعدات الرد السريع عندما تبدأ المحادثة بالتحرك.',
          },
        ],
      },
      outreach: {
        accent: 'التواصل',
        title: 'بحث استباقي لا انتظار سلبي',
        description: 'هذه المساحة مخصصة للتواصل المستهدف مع الشركات حتى يحافظ الباحث عن عمل على مسار نظيف من المحادثات الدافئة.',
        stats: [
          { label: 'الوضع', value: 'صادر' },
          { label: 'الإيقاع', value: 'مخطط' },
          { label: 'الأولوية', value: 'مقصودة' },
        ],
        lanes: [
          {
            title: 'قائمة الشركات',
            body: 'تتبع من تواصلت معه ومتى تواصلت وما زاوية الرسالة التي استخدمتها لكل شركة.',
          },
          {
            title: 'صف المتابعة',
            body: 'اعرف من يحتاج إلى متابعة ثانية وأي المحادثات بدأت تبرد قبل أن تصمت.',
          },
          {
            title: 'مختبر الرسائل',
            body: 'خصص مساحة لمسودات تواصل شخصية مرتبطة بفرص وشركات محددة.',
          },
        ],
      },
      careerCoach: {
        accent: 'المدرب المهني',
        title: 'طبقة تدريب تصقل تموضعك',
        description: 'هذه الشاشة مخصصة لصياغة السرد المهني والاستعداد للمقابلات وتوجيه الخطوة التالية حول ملف الباحث.',
        stats: [
          { label: 'التركيز', value: 'السرد' },
          { label: 'الصيغة', value: 'إرشاد' },
          { label: 'الجاهزية', value: 'محجوزة' },
        ],
        lanes: [
          {
            title: 'تشذيب القصة',
            body: 'حوّل الخبرات الخام إلى عرض شخصي أوضح يطابق الوظائف التي تستهدفها.',
          },
          {
            title: 'تدريب المقابلات',
            body: 'استعد للمقابلات المهمة بتمارين قصيرة وموجّهة حسب نوع الدور.',
          },
          {
            title: 'الخطة الأسبوعية',
            body: 'حوّل الطموح إلى خطة تشغيل قصيرة قابلة للتنفيذ هذا الأسبوع.',
          },
        ],
      },
      companyRadar: {
        accent: 'رادار الشركات',
        title: 'أبقِ الشركات المستهدفة ضمن الرؤية',
        description: 'هذه الشاشة مخصصة لتتبع الشركات وإشارات التوظيف وملاحظات الملاءمة حتى يذهب جهد البحث إلى المكان الصحيح.',
        stats: [
          { label: 'العدسة', value: 'شركات مستهدفة' },
          { label: 'نوع الإشارة', value: 'حركة توظيف' },
          { label: 'الحالة', value: 'منظمة' },
        ],
        lanes: [
          {
            title: 'قائمة المراقبة',
            body: 'ثبّت الشركات التي تهمك وتابع من يوظف وأين يحدث التحرك وما الذي تغير حديثًا.',
          },
          {
            title: 'ملاحظات الملاءمة',
            body: 'سجّل سبب أهمية الشركة بالنسبة لك قبل أن يبدأ سباق التقديم ويفقدك السياق.',
          },
          {
            title: 'مسارات الدخول الدافئة',
            body: 'اترك مساحة للإحالات وإشارات المدراء والزوايا الذكية للدخول إلى المحادثة.',
          },
        ],
      },
      learningPathways: {
        accent: 'مسارات التعلّم',
        title: 'تعلّم مرتبط بفجوات الفرص الحقيقية',
        description: 'هذه المساحة مخصصة لخطط التعلّم التي تغلق الفجوة بين ملفك الحالي والوظائف التي تريدها.',
        stats: [
          { label: 'التوجه', value: 'مرتبط بالمهنة' },
          { label: 'السرعة', value: 'وحدات' },
          { label: 'الحالة', value: 'جاهزة' },
        ],
        lanes: [
          {
            title: 'مخطط الدور المستهدف',
            body: 'ابدأ من الدور المطلوب وقسّم القدرات المطلوبة إلى كتل عملية قابلة للتعلّم.',
          },
          {
            title: 'رسم الفجوات',
            body: 'حدّد الإشارات الناقصة التي تتكرر عبر الفرص وحوّلها إلى مراحل واضحة.',
          },
          {
            title: 'مؤشرات التقدم',
            body: 'اترك مساحة لإثبات العمل والخطوات المنجزة والإشارات المهنية القابلة للعرض.',
          },
        ],
      },
    },
    profile: {
      identity: 'الهوية',
      title: 'شكّل ما يراه صاحب العمل أولًا',
      fields: {
        fullName: 'الاسم الكامل',
        email: 'البريد الإلكتروني',
        targetRole: 'الدور المستهدف',
        location: 'الموقع',
        phoneNumber: 'رقم الهاتف',
        summary: 'الملخص المهني',
      },
      placeholders: {
        targetRole: 'مثال: مديرة نمو للمنتج',
        location: 'مثال: بيروت',
        phoneNumber: '+961 ...',
        summary: 'اكتب ملخصًا قصيرًا عن نوع العمل الذي تريده، وما تجيده، وما الذي يجب أن يلاحظه أصحاب العمل.',
      },
      openToWork: 'أظهرني كمتاح للعمل.',
      save: 'حفظ الملف',
      saving: 'جارٍ الحفظ...',
      updated: 'تم تحديث الملف.',
      failed: 'تعذّر حفظ الملف الآن.',
      readiness: {
        eyebrow: 'الجاهزية',
        title: 'إشارة الباحث عن عمل',
        status: 'الحالة',
        onboarding: 'الإعداد',
        targetRole: 'الدور المستهدف',
        live: 'نشط',
        private: 'خاص',
        unset: 'غير مضبوط',
      },
      nextLayer: {
        eyebrow: 'الطبقة التالية',
        title: 'عناصر الإعداد القادمة',
        body: 'هذه الصفحة تترك مساحة للشاشات التي سنضيفها بعد المصادقة: رفع السيرة الذاتية وتفضيلات البحث وتصاريح العمل وإعدادات التدريب.',
      },
    },
    opportunityFeed: {
      title: 'وظائف وجدتها لك',
      sort: { label: 'الترتيب:', aria: 'ترتيب الوظائف', recommended: 'الأكثر ملاءمة', recent: 'الأحدث' },
      manual: {
        title: 'ابحث في الوظائف المتاحة',
        aria: 'البحث اليدوي عن وظائف',
        queryLabel: 'الدور أو المهارة أو الشركة',
        queryPlaceholder: 'الدور أو المهارة أو الشركة',
        locationLabel: 'موقع الوظيفة',
        locationPlaceholder: 'المدينة أو الدولة',
        workModeLabel: 'نمط العمل',
        allModes: 'جميع أنماط العمل',
        remote: 'عن بُعد',
        hybrid: 'هجين',
        onSite: 'من مقر العمل',
        resultCount: 'عرض {count} وظيفة',
        listing: 'وظيفة متاحة',
        empty: 'لا توجد وظائف متاحة تطابق معايير البحث. جرّب إزالة أحد عوامل التصفية.',
      },
      promo: {
        eyebrow: 'JOBSEEQR PRO',
        title: 'دع الوظائف المناسبة تصل إليك.',
        description: 'يعثر لك JOBSEEQR على وظائف بناءً على خبرتك والوظائف والمواقع التي تفضّلها، ثم يرتّب الوظائف التي تناسبك بشكل أفضل.',
        action: 'ابدأ تشغيل مساعدي · 20 دولاراً شهرياً',
        expiredTitle: 'حافظ على نشاط بحثك عن عمل.',
        expiredDescription: 'تم حفظ الوظائف والمواقع والتفضيلات التي اخترتها. قم بالترقية كي يواصل JOBSEEQR البحث عن الوظائف نيابةً عنك.',
        expiredAction: 'أبقِ مساعدي نشطاً · 20 دولاراً شهرياً',
        opening: 'جارٍ فتح الدفع الآمن…',
      },
      trial: {
        eyebrow: 'تجربة المساعد نشطة',
        closingEyebrow: 'تجربة المساعد · بقي أقل من يوم',
        title: 'مساعدك يعمل الآن',
        includedUntil: 'البحث المخصص والتواصل عبر المساعد متاحان حتى {date}.',
        closingTitle: 'سيتوقف مساعدك مؤقتاً يوم {day}.',
        closingDescription: 'قم بالترقية لمواصلة البحث الآلي عن الوظائف والتواصل من دون إعداد كل شيء من جديد.',
        oneMatch: 'رتّب المساعد {count} وظيفة مخصصة حتى الآن.',
        matches: 'رتّب المساعد {count} وظائف مخصصة حتى الآن.',
        action: 'أبقِه يعمل بعد التجربة',
        closingAction: 'المتابعة مع Pro · 20 دولاراً شهرياً',
        opening: 'جارٍ فتح الدفع الآمن…',
      },
      cv: {
        title: 'احصل على وظائف أكثر ملاءمة',
        description: 'حمّل سيرتك الذاتية أو أنشئ واحدة مع المدرب المهني لتحسين النتائج.',
        upload: 'تحميل السيرة الذاتية',
        uploading: 'جارٍ التحميل…',
        build: 'إنشاؤها مع المدرب المهني',
        buildPrefill: 'ساعدني في إنشاء سيرة ذاتية من البداية.',
        pdfOnly: 'يرجى اختيار سيرة ذاتية بصيغة PDF.',
        refreshFailed: 'تم تحميل سيرتك الذاتية، لكن تعذّر على المساعد تحديث النتائج الآن. حاول لاحقاً.',
        uploadedRefreshing: 'تم تحميل السيرة الذاتية. يعمل المساعد الآن على تحسين النتائج.',
        uploaded: 'تم تحميل السيرة الذاتية وستُستخدم في النتائج القادمة.',
        uploadFailed: 'تعذّر تحميل سيرتك الذاتية. حاول مرة أخرى.',
      },
      tabs: { aria: 'أقسام موجز الوظائف', all: 'وظائف مناسبة لك', recent: 'آخر 24 ساعة', browse: 'تصفّح الكل', applied: 'تم التقديم' },
      states: {
        updated: 'يبحث مساعدك المحدّث عن نتائج جديدة الآن. سنُبقي الوظائف السابقة ظاهرة إلى أن تصبح النتائج الجديدة جاهزة.',
        searching: 'يبحث مساعدك عبر الويب. نعرض أدناه وظائف مباشرة مرتبطة بدورك المستهدف بينما نجهّز النتائج المخصصة.',
        empty: 'النتائج المخصصة ليست جاهزة بعد. نعرض أدناه وظائف مباشرة مرتبطة بدورك المستهدف.',
        incomplete: 'حصل المساعد على تغطية جزئية للسوق وسيواصل التحديث. نتائجك السابقة محفوظة.',
        failed: 'تعذّر إكمال آخر تحديث للسوق وستتم إعادة المحاولة تلقائياً. نتائجك السابقة محفوظة.',
        setup: 'يجري إنشاء مساعد الوظائف الآن. ستظهر النتائج المخصصة هنا فور اكتمال الإعداد.',
        retry: 'إجاباتك محفوظة. واجه إعداد مساعد الوظائف مشكلة مؤقتة وتتم إعادة المحاولة تلقائياً.',
        loadingApplications: 'جارٍ تحميل نشاط طلباتك…',
        noApplied: 'لم تتقدم إلى أي وظيفة في هذا الموجز بعد.',
        noRecent: 'لم يتم العثور على وظائف جديدة خلال آخر 24 ساعة.',
        noMatches: 'لا توجد نتائج وظيفية جاهزة بعد.',
        reviewPending: 'يعيد مساعدك محاولة مراجعة بعض الوظائف. يمكنك متابعة التصفح ريثما ينتهي.',
        reviewUnavailable: 'تعذّر إكمال بعض مراجعات الوظائف. يمكنك متابعة البحث واستخدام أي نتائج متاحة.',
        reviewUncertain: 'تحتاج بعض الوظائف إلى معلومات إضافية قبل أن يؤكد مساعدك ملاءمتها لك.',
      },
      jobs: {
        untitled: 'وظيفة بلا عنوان', unknownCompany: 'شركة غير معروفة', detailsPending: 'التفاصيل قريباً',
        salaryUnavailable: 'الراتب غير متوفر', today: 'نُشرت اليوم', yesterday: 'نُشرت أمس', daysAgo: 'نُشرت منذ {count} أيام',
        matchPending: 'الملاءمة قيد التقييم', excellent: 'ملاءمة ممتازة', strong: 'ملاءمة قوية', good: 'ملاءمة جيدة', potential: 'ملاءمة محتملة',
        status: 'حالة الوظيفة', new: 'جديدة', applied: 'تم التقديم', notForMe: 'لا تناسبني', why: 'أخبر المساعد بالسبب:',
        feedbackFailed: 'تعذّر حفظ ملاحظتك. حاول مرة أخرى.',
      },
      dismiss: { wrongRole: 'الدور غير مناسب', wrongIndustry: 'القطاع غير مناسب', wrongLocation: 'الموقع غير مناسب', tooSenior: 'مستوى أعلى من المطلوب', tooJunior: 'مستوى أدنى من المطلوب', other: 'سبب آخر' },
      market: { title: 'وظائف مرتبطة بدورك المستهدف', description: 'هذه وظائف مباشرة على JOBSEEQR يمكنك مراجعتها بينما يجهّز المساعد نتائجك الشخصية ويرتّبها.', general: 'وظيفة مرتبطة', empty: 'لا توجد وظائف مباشرة مرتبطة بدورك بعد.' },
      radar: { title: 'قائمة الشركات المختارة', openAria: 'فتح قائمة الشركات المختارة', open: 'فتح القائمة', loading: 'جارٍ تحميل رادار الشركات', emptyTitle: 'أنشئ خارطة طريق للشركات المستهدفة', emptyDescription: 'ابحث في المكاتب والملاءمة والعوائق والتأشيرات والخطوات التالية.' },
      tokens: { onSite: 'من مقر العمل', fullTime: 'دوام كامل', partTime: 'دوام جزئي', perYear: '/سنة', upTo: 'حتى' },
    },
    careerCoachHub: {
      title: 'ماذا تريد أن تفعل اليوم؟',
      nodes: { interviews: 'تدرّب على\nالمقابلات', ask: 'اسألني\nأي شيء', scout: 'اضبط مساعد\nالبحث', careers: 'استكشف\nالمسارات المهنية' },
      update: 'يعمل مساعد البحث المحدّث في الخلفية. ستبقى وظائفك السابقة ظاهرة حتى تجهز النتائج الجديدة.',
      focusTitle: 'تركيزك الرئيسي الآن هو…',
      scoutTitle: 'مساعد البحث عن وظائف',
      scoutDescription: 'سأبحث لك عن وظائف بهذه المسميات.',
      noTitles: 'لم تُضبط مسميات وظيفية بعد.',
      addMore: 'إضافة المزيد',
      defaultFocus: 'أبحث الآن عن فرص تناسب خبرتي وتفضيلاتي وخطوتي المهنية التالية.',
    },
    activeGoals: {
      title: 'الأهداف الأسبوعية', history: 'السجل', weeklyHistory: 'السجل الأسبوعي', save: 'حفظ', cancel: 'إلغاء', edit: 'تعديل',
      target: 'هدف {title}', applicationPeriod: 'مدة هدف طلبات التوظيف', perDay: 'يومياً', perWeek: 'أسبوعياً',
      empty: 'يساعدك وكيلك المهني على الاستمرار عبر أهداف أسبوعية لطلبات التوظيف والتدرّب على المقابلات وبناء العلاقات.',
      setGoals: 'تحديد الأهداف', today: 'اليوم', thisWeek: 'هذا الأسبوع', deadlineToday: 'اليوم', deadlineWeek: 'هذا الأسبوع',
      completeToday: 'أكمل {target} من {unit} اليوم', completeBy: 'أكمل {target} من {unit} بحلول {date}', completeWeek: 'أكمل {target} من {unit} هذا الأسبوع',
      undo: 'التراجع عن آخر {unit}', progress: 'اكتمل {current} من {target} {unit}', weekTotal: 'هذا الأسبوع: {count}',
      networkingRecommended: 'أشخاص مقترحون لبناء علاقات مهنية',
      types: {
        applications: { title: 'طلبات التوظيف', goalTitle: 'هدف طلبات التوظيف', unit: 'طلبات', targetUnit: 'طلبات توظيف', logLabel: 'تسجيل طلب' },
        interviews: { title: 'مقابلات تدريبية', goalTitle: 'هدف المقابلات', unit: 'مقابلات', targetUnit: 'مقابلات تدريبية', logLabel: 'تسجيل مقابلة' },
        networking: { title: 'محادثات مهنية', goalTitle: 'هدف العلاقات المهنية', unit: 'محادثات', targetUnit: 'محادثات مهنية', logLabel: 'تسجيل محادثة' },
      },
    },
    inboxPage: {
      loading: 'جارٍ التحميل…', label: 'صندوق الوارد', title: 'صندوق الوارد', subtitle: 'الشركات التي تتواصل معها حالياً', sections: 'أقسام صندوق الوارد',
      messages: 'الرسائل', outreach: 'التواصل', noConversations: 'لا توجد محادثات نشطة بعد.', noOutreach: 'لا توجد حملات تواصل نشطة بعد.',
      company: 'الشركة', rolePending: 'الدور قيد المتابعة', unread: 'رسائل غير مقروءة', noMessages: 'لا توجد رسائل بعد', loadingMessages: 'جارٍ تحميل الرسائل…', loadingOutreach: 'جارٍ تحميل التواصل',
      recipientsEmails: '{recipients} مستلمين · {emails} رسائل', contacts: 'جهات التواصل', contact: 'جهة اتصال', hiringTeam: 'فريق التوظيف', cancelContact: 'إلغاء التواصل',
      pause: 'إيقاف مؤقت', cancel: 'إلغاء', back: 'رجوع', noThreadMessages: 'لا توجد رسائل في هذه المحادثة بعد.', typeMessage: 'اكتب رسالة', message: 'رسالة', send: 'إرسال الرسالة', selectCompany: 'اختر شركة لعرض الرسائل.',
      status: { active: 'نشطة', paused: 'متوقفة مؤقتاً', cancelled: 'ملغاة', completed: 'مكتملة' },
    },
    profilePage: {
      jobSeeker: 'باحث عن عمل', openToWork: 'متاح للعمل', menu: 'قائمة الملف الشخصي', edit: 'تعديل الملف', settings: 'الإعدادات', signOut: 'تسجيل الخروج',
      editLabel: 'تعديل الملف الشخصي', firstName: 'الاسم الأول', lastName: 'اسم العائلة', email: 'البريد الإلكتروني', phone: 'الهاتف', location: 'الموقع', linkedin: 'LinkedIn', portfolio: 'معرض الأعمال', saving: 'جارٍ الحفظ…', save: 'حفظ التغييرات', cancel: 'إلغاء',
      contact: 'بيانات التواصل', noEmail: 'لم يُضف بريد إلكتروني', noPhone: 'لم يُضف رقم هاتف', noLocation: 'لم يُضف موقع', noLinkedin: 'لم يُضف LinkedIn', uploadedCv: 'السيرة الذاتية المحمّلة', noCv: 'لم تُحمّل سيرة ذاتية بعد', noPortfolio: 'لم يُضف رابط معرض أعمال',
      assessedBadges: 'شارات المهارات المقيّمة', certificates: 'شهادات JOBSEEQR', showLess: 'عرض أقل', more: '+ {count} إضافية',
      billing: {
        title: 'الفوترة', freePlan: 'الخطة المجانية', proPlan: 'خطة Pro', trialEnds: 'تنتهي تجربة المساعد في {date}', accessEnds: 'ينتهي وصول Pro في {date}',
        upgradeTitle: 'طوّر بحثك عن عمل مع Pro.', upgradeDescription: 'مساعد البحث والتواصل ومسارات التعلّم والتدرّب على المقابلات ورادار الشركات والمدرب المهني.',
        freePrice: '0 دولار', proPrice: '20 دولاراً', perMonth: '/شهرياً', upgrade: 'الترقية إلى Pro · 20 دولاراً شهرياً', manage: 'إدارة الفوترة', opening: 'جارٍ الفتح…',
        success: 'أصبحت على خطة Pro. يجري تحديث وصولك الآن.', cancelled: 'تم إلغاء الدفع ولم تُخصم أي رسوم.',
      },
    },
    careerPathsPage: {
      label: 'المسارات المهنية', nextMoves: 'خطواتك المهنية التالية', categories: 'فئات المسارات المهنية', back: 'رجوع', description: 'قارن أدواراً واقعية بحسب الملاءمة وفرص التوظيف والعمل المطلوب للوصول إليها.', roleDescription: 'راجع فرص التوظيف والملاءمة والفجوات والخطوات التالية لهذا الدور.',
      intentTitle: 'ما نوع الخطوة المهنية التالية التي تستكشفها؟', intentDescription: 'اختر اتجاهاً واحداً. إذا اخترت تغيير المسار، فأخبرنا بالمجال أو الدور الذي تريده.', direction: 'اتجاه المسار المهني', pivotQuestion: 'إلى أي مجال أو دور تريد الانتقال؟', pivotPlaceholder: 'مثال: محلل بيانات', starting: 'جارٍ البدء…', showPaths: 'اعرض مساراتي',
      modes: { promotion: { label: 'تقدّم', prompt: 'التقدّم في مساري الحالي', description: 'اختره إذا أردت دوراً أعلى مستوى ضمن نوع العمل نفسه.' }, parallel: { label: 'انتقل', prompt: 'الانتقال إلى دور قريب', description: 'اختره إذا أردت دوراً قريباً يستخدم مهاراتك الحالية.' }, pivoting: { label: 'غيّر المسار', prompt: 'الانتقال إلى مجال جديد', description: 'اختره إذا أردت نوعاً جديداً من الأدوار وتحتاج إلى خطة واضحة.' } },
      loadingTitle: 'جارٍ تحميل مساراتك المهنية', loadingDescription: 'نتحقق مما إذا كانت لديك نتائج محفوظة.', buildingTitle: 'نبني خطواتك التالية', buildingDescription: 'قد يستغرق ذلك لحظات بينما نراجع ملفك والسوق.', errorTitle: 'يحتاج إنشاء المسارات المهنية إلى محاولة أخرى', errorFallback: 'لم يكتمل قسم واحد أو أكثر.', startError: 'تعذّر بدء إنشاء المسارات المهنية.', retry: 'إعادة المحاولة', empty: 'لا توجد توصيات متاحة لهذا القسم بعد.', sources: 'المصادر', source: 'مصدر', pathSummary: 'ملخص المسار', pathRatings: 'تقييمات المسار',
      fit: 'الملاءمة', work: 'الجهد', outlook: 'السوق', hiringOutlook: 'فرص التوظيف', effort: 'مقدار العمل المطلوب', moreProof: 'توقّع الحاجة إلى بناء أدلة أكثر.', currentProof: 'ابنِ انطلاقاً من أدلتك الحالية.', alreadyHave: 'مهارات تمتلكها بالفعل', skillsToBuild: 'مهارات تحتاج إلى بنائها', next30: 'خطوات الثلاثين يوماً', next90: 'مسار التسعين يوماً', people: 'أشخاص للتحدث معهم', official: 'بيانات رسمية', estimate: 'تقدير', liveCheck: 'يحتاج إلى تحقق مباشر', growing: 'ينمو', limited: 'محدود', steady: 'مستقر', rolesExist: 'توجد وظائف متاحة', confirmPosts: 'تحقق من إعلانات الوظائف الحالية.', openings: '{count} فرصة سنوياً', projected: 'تغيّر متوقع {value}٪',
      recommendedPath: 'مسار مقترح', ninetyDays: '٩٠ يوماً', fitLabels: { strong: 'قوية', promising: 'واعدة', stretch: 'طموحة' }, effortLabels: { low: 'منخفض', medium: 'متوسط', high: 'مرتفع' },
    },
    askAnythingPage: {
      label: 'اسألني عن أي شيء', loadingChats: 'جارٍ تحميل محادثات المدرب المهني', loading: 'جارٍ التحميل…', back: 'رجوع', defaultTitle: 'محادثة إرشاد مهنية جديدة',
      openChats: 'فتح المحادثات السابقة', previousChats: 'المحادثات السابقة', chats: 'المحادثات', closeChats: 'إغلاق المحادثات السابقة', newChat: 'محادثة جديدة', startFresh: 'ابدأ من جديد', newChatDescription: 'المسار المهني، الشركات، الدورات، الرواتب، السيرة الذاتية، القطاعات، المقابلات، أو JOBSEEQR.', coach: 'مدرب JOBSEEQR المهني', answerLoading: 'جارٍ تحميل الإجابة', noMessages: 'لا توجد رسائل بعد', deleteChat: 'حذف {title}', delete: 'حذف المحادثة',
      helpTitle: 'بماذا يمكنني مساعدتك؟', suggested: 'أسئلة مقترحة', suggestions: ['كيف يمكنني تحسين سيرتي الذاتية؟', 'ما الأدوار الأنسب لي؟', 'ما الراتب الذي ينبغي أن أستهدفه؟', 'كيف أستعد للمقابلات؟'],
      sources: 'المصادر', cvOptions: 'خيارات السيرة الذاتية', cvSections: 'أقسام مسودة السيرة الذاتية', copy: 'نسخ الإجابة', chooseCv: 'اختر خياراً للسيرة الذاتية', chooseAbove: 'اختر أحد الخيارات أعلاه.', placeholder: 'اكتب سؤالاً مهنياً', question: 'سؤال للمدرب المهني', send: 'إرسال السؤال',
      searching: 'جارٍ البحث في مصادر مهنية محدّثة…', brewing: 'جارٍ إعداد إجابتك…', noAnswer: 'وجدت مصادر، لكنني لم أتمكن من صياغة إجابة.', blocked: 'يمكنني المساعدة فقط في أسئلة المسار المهني وJOBSEEQR.', temporaryError: 'واجهت خدمة الأسئلة مشكلة مؤقتة.',
      cvSessionTitle: 'جلسة إنشاء السيرة الذاتية وتعديلها', cvReading: 'جارٍ قراءة سيرتك الذاتية…', cvThinking: 'جارٍ العمل على سيرتك الذاتية…', cvGenerating: 'جارٍ إنشاء سيرتك الذاتية وحفظها…', cvCreatingSaving: 'جارٍ إنشاء سيرتك الذاتية وحفظها…', cvSaved: 'تم إنشاء سيرتك الذاتية الجديدة وحفظها في ملفك الشخصي.\n\n[فتح السيرة الذاتية المحفوظة]({url})', cvTemporaryError: 'واجهت جلسة إنشاء السيرة الذاتية وتعديلها مشكلة مؤقتة.',
    },
    settings: {
      backToProfile: 'العودة إلى الملف الشخصي',
      title: 'الإعدادات',
      appearance: {
        title: 'المظهر',
        description: 'اختر مستوى السطوع الأنسب لمساحة عملك.',
        light: 'فاتح',
        dark: 'داكن',
        switchToLight: 'التبديل إلى الوضع الفاتح',
        switchToDark: 'التبديل إلى الوضع الداكن',
      },
      language: {
        eyebrow: 'اللغة واتجاه العرض',
        title: 'اختر لغة مساحة العمل',
        description: 'يغيّر هذا الخيار لغة التنقل وعناصر التحكم واللغة التي يستخدمها JOBSEEQR عند التحدث معك.',
        englishName: 'الإنجليزية',
        englishNative: 'English',
        arabicName: 'العربية',
        arabicNative: 'العربية',
        ltr: 'من اليسار إلى اليمين',
        rtl: 'من اليمين إلى اليسار',
        selected: 'محددة',
        saving: 'جارٍ حفظ التفضيل…',
        saved: 'تم حفظ تفضيل اللغة.',
        failed: 'تعذّر حفظ تفضيل اللغة. حاول مرة أخرى.',
      },
      legal: {
        title: 'المعلومات القانونية',
        terms: 'شروط الخدمة',
        privacy: 'سياسة الخصوصية',
      },
      email: {
        title: 'البريد الآلي للتواصل المهني',
        description: 'اربط Gmail أو Outlook ليتمكن JOBSEEQR من إرسال رسائل التواصل وقراءة الردود ضمن تسلسلاتك النشطة.',
        checking: 'جارٍ التحقق…',
        connected: 'متصل',
        notConnected: 'غير متصل',
        connectedAccount: 'حساب متصل',
        connectYour: 'اربط بريد',
        connect: 'ربط',
        opening: 'جارٍ الفتح…',
        disconnect: 'قطع الاتصال',
        disconnecting: 'جارٍ قطع الاتصال…',
        disconnected: 'تم قطع اتصال البريد الإلكتروني.',
        checkingProviders: 'جارٍ التحقق من حسابات البريد المتصلة',
        connectedForOutreach: 'متصل للتواصل الآلي.',
        connectionFailed: 'فشل ربط البريد الإلكتروني',
      },
      danger: {
        title: 'منطقة الإجراءات الحساسة',
        description: 'احذف ملفك وفهرس طلباتك واتصالات الرسائل المرتبطة به.',
        confirmation: 'اكتب DELETE للتأكيد',
        delete: 'حذف الحساب',
        deleting: 'جارٍ الحذف…',
        recentLogin: 'سجّل الخروج ثم ادخل مجددًا وأعد محاولة حذف الحساب.',
        failed: 'تعذّر حذف الحساب. حاول مرة أخرى.',
      },
    },
  },
};
